module.exports = __webpack_public_path__ + "static/media/tlyfe-tab.8f9ee6a7.png";